import React from 'react';
import StaffLayoutPage from './staffPageLayout';
import StaffExplorePage from './staffExplorePage';
import { useFinanceData } from '../licenseAnalyticsPage/financePage';

interface FinancePageProps {
  mode: string;
}

const StaffPage: React.FC<FinancePageProps> = React.memo(({ mode }) => {
  useFinanceData();
  return <>{mode === 'Dashboard' ? <StaffLayoutPage /> : <StaffExplorePage />}</>;
});

export default StaffPage;
